'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _noop2 = require('lodash/noop');

var _noop3 = _interopRequireDefault(_noop2);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _mobxReact = require('mobx-react');

var _format = require('date-fns/format');

var _format2 = _interopRequireDefault(_format);

var _add_weeks = require('date-fns/add_weeks');

var _add_weeks2 = _interopRequireDefault(_add_weeks);

var _classAutobindDecorator = require('class-autobind-decorator');

var _classAutobindDecorator2 = _interopRequireDefault(_classAutobindDecorator);

var _Button = require('react-bootstrap/lib/Button');

var _Button2 = _interopRequireDefault(_Button);

var _Row = require('react-bootstrap/lib/Row');

var _Row2 = _interopRequireDefault(_Row);

var _DateInput = require('../common-formsy/DateInput');

var _DateInput2 = _interopRequireDefault(_DateInput);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var WEEK_VALUES = [4, 8, 12, 16]; // eslint-disable-line no-magic-numbers

var FollowUpDateInput = (0, _classAutobindDecorator2.default)(_class = (0, _mobxReact.observer)(_class = (_temp = _class2 = function (_Component) {
  _inherits(FollowUpDateInput, _Component);

  function FollowUpDateInput() {
    _classCallCheck(this, FollowUpDateInput);

    return _possibleConstructorReturn(this, (FollowUpDateInput.__proto__ || Object.getPrototypeOf(FollowUpDateInput)).apply(this, arguments));
  }

  _createClass(FollowUpDateInput, [{
    key: 'handleQuickFollowDateClick',
    value: function handleQuickFollowDateClick(e) {
      var value = (0, _add_weeks2.default)(new Date(), e.target.value),
          formattedDate = (0, _format2.default)(value, 'YYYY-MM-DD');

      this.props.onChange(formattedDate);
    }
  }, {
    key: 'renderQuickFollowUpDateButtons',
    value: function renderQuickFollowUpDateButtons() {
      var _this2 = this;

      return _react2.default.createElement(
        'div',
        { className: 'quick-dates' },
        _react2.default.createElement(
          'span',
          { className: 'title' },
          'Follow up in:'
        ),
        WEEK_VALUES.map(function (weeks, idx) {
          return _react2.default.createElement(
            _react.Fragment,
            { key: weeks },
            idx > 0 && _react2.default.createElement(
              'span',
              null,
              '/'
            ),
            _react2.default.createElement(
              _Button2.default,
              {
                bsSize: 'small',
                bsStyle: 'link',
                id: 'btn-weeks-' + weeks,
                onClick: _this2.handleQuickFollowDateClick,
                value: weeks
              },
              weeks,
              ' Weeks'
            )
          );
        })
      );
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _react.Fragment,
        null,
        _react2.default.createElement(
          _Row2.default,
          null,
          _react2.default.createElement(_DateInput2.default, _extends({
            manual: true,
            name: 'trackingFollowUpDate',
            positionTop: true
          }, this.props)),
          this.renderQuickFollowUpDateButtons()
        )
      );
    }
  }, {
    key: '__reactstandin__regenerateByEval',
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return FollowUpDateInput;
}(_react.Component), _class2.defaultProps = {
  onChange: _noop3.default
}, _class2.propTypes = {
  label: _propTypes2.default.string,
  onChange: _propTypes2.default.func,
  value: _propTypes2.default.string
}, _temp)) || _class) || _class;

var _default = FollowUpDateInput;
exports.default = _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(WEEK_VALUES, 'WEEK_VALUES', '/app/src/components/page-tasks/FollowUpDateInput.js');
  reactHotLoader.register(FollowUpDateInput, 'FollowUpDateInput', '/app/src/components/page-tasks/FollowUpDateInput.js');
  reactHotLoader.register(_default, 'default', '/app/src/components/page-tasks/FollowUpDateInput.js');
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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